import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'
import { colors } from '../../utils/theme/styles'
import InputForm from '../InputForm/InputForm'
import { REPOSITORY } from '../../api/repository/Repository'
import { useLoadingContext } from '../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../utils/hooks/Context/RequestStatusContext'
import RefillDetail from './RefillDetail'
import { parse, format } from 'date-fns'
import { numberFormat } from '../../utils/formats/formats'

const Info = ({ label, data }) => {
  return (
    <HStack w="100%" justifyContent="space-between">
      <Heading variant="h5">{label}</Heading>
      <Heading variant="h5">{data}</Heading>
    </HStack>
  )
}

Info.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
}

export default function ConfirmRefill({ open, onClose, data, onConfirmed }) {
  console.log('data ->', data)
  const [user, setUser] = useState('')
  const [password, setPassword] = useState('')
  const [detailState, setDetailState] = useState({
    nAsignacion: '',
    open: false,
  })

  // const handleClick = useCallback(() => {
  //   setDetailState((prevState) => ({
  //     ...prevState,
  //     nAsignacion: data.nAsignacion,
  //     open: true,
  //   }))
  // }, [data])

  const handleCloseDetail = useCallback(() => {
    setDetailState({ nAsignacion: '', open: false })
  }, [])

  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const onCloseStatus = () => {
    handleClose()
    onClose()
  }

  const onOkStatus = useCallback(
    (response) => {
      onConfirmed()
      handleCLoseLoading()
      handleSetTitle(response.data.sMensaje, response.status)
      handleChangeBody(
        <Button variant="primary" onClick={onCloseStatus}>
          {response.status === 200
            ? 'Continuar'
            : 'Contactar a ejecutivo ahora'}
        </Button>,
      )
      handleOpen()
    },
    [handleCLoseLoading, handleChangeBody, handleOpen, handleSetTitle],
  )

  const onErrorStatus = useCallback(
    (error) => {
      handleCLoseLoading()
      handleSetTitle(error.response.data.error, error.response.status)
      handleChangeBody(
        <Button variant="primary" onClick={onCloseStatus}>
          {error.status === 200 ? 'Continuar' : 'Contactar a ejecutivo ahora'}
        </Button>,
      )
      handleOpen()
    },
    [handleCLoseLoading, handleChangeBody, handleOpen, handleSetTitle],
  )

  const handleChangeUser = (event) => {
    setUser(event.target.value)
  }
  const handleChangePassword = (event) => {
    setPassword(event.target.value)
  }

  const onConfirm = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.refills
      .confirmRefill(user, password, data.nAsignacion)
      .then((res) => onOkStatus(res))
      .catch((error) => onErrorStatus(error))
  }

  const onDecline = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.refills
      .declineRefill(user, password, data.nAsignacion)
      .then((res) => onOkStatus(res))
      .catch((error) => onErrorStatus(error))
  }
  return (
    <Modal isOpen={open} size="2xl" onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius={20}>
        <ModalHeader
          bgColor={colors.gray[600]}
          borderRadius="20px 20px 0px 0px"
        >
          <HStack>
            <Heading color={colors.gray[50]} variant="h4">
              Autorización de recarga
            </Heading>
          </HStack>
        </ModalHeader>
        <ModalCloseButton color={colors.gray[50]} top={5} fontSize={15} />
        <ModalBody bg="#EEEEEE" borderRadius="0px 0px 20px 20px">
          <VStack alignItems="flex-start" w="100%" p="16px">
            <VStack w="100%" spacing="7px">
              <Info label="Número de recarga:" data={data.nAsignacion} />
              <Info
                label="Fecha creación:"
                data={
                  data.dAsignacion &&
                  format(
                    parse(data.dAsignacion, 'dd-MM-yyyy', new Date()),
                    'MMM dd, yyyy',
                  )
                }
              />
              <Info
                label="Fecha ejecución:"
                data={format(new Date(), 'MMM dd, yyyy')}
              />
              <Info
                label="Cantidad de colaboradores:"
                data={data.nCantidadCuentas}
              />
              <Info
                label="Monto a recargar:"
                data={numberFormat(data.nMontoTotal, 'currency')}
              />
              {/* <Button alignSelf="self-start" w="200px" onClick={handleClick}>
                Ver nomina
              </Button> */}
            </VStack>
            <VStack spacing="10px" alignItems="flex-start" w="100%" pt={3}>
              <VStack w="100%">
                <InputForm
                  borderColor="#40A4E0"
                  stackProps={{ width: '100%' }}
                  onChange={handleChangeUser}
                  value={user}
                  titleHeading
                  variant="h6"
                  w="100%"
                  title="Usuario"
                  placeholder="USERNAME"
                />
              </VStack>
              <VStack w="100%">
                <InputForm
                  placeholder="*******"
                  borderColor="#40A4E0"
                  type="password"
                  stackProps={{ width: '100%' }}
                  onChange={handleChangePassword}
                  value={password}
                  titleHeading
                  variant="h6"
                  w="100%"
                  title="Clave"
                />
              </VStack>
            </VStack>
            <HStack
              pt={10}
              w="100%"
              alignSelf="center"
              justifyContent="space-between"
            >
              <Button
                onClick={onDecline}
                w="247px"
                h="56px"
                borderRadius="15px"
                variant="error"
              >
                RECHAZAR RECARGA
              </Button>
              <Button
                w="247px"
                h="56px"
                borderRadius="15px"
                onClick={onConfirm}
                variant="primary"
              >
                AUTORIZAR RECARGA
              </Button>
            </HStack>
          </VStack>
          <RefillDetail
            nAsignacion={detailState.nAsignacion}
            open={detailState.open}
            onClose={handleCloseDetail}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

ConfirmRefill.propTypes = {
  data: PropTypes.shape({
    CentroCosto: PropTypes.string,
    nAsignacion: PropTypes.any,
    nCantidadCuentas: PropTypes.number,
    nMontoTotal: PropTypes.string,
    dAsignacion: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onConfirmed: PropTypes.func,
  open: PropTypes.bool,
}
